import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Container, Paper, Stack, TextField, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getAdminMe, loginAdmin } from '../services/admin';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem('vpn_admin_token');
    if (!token) return undefined;
    getAdminMe()
      .then(() => { if (!cancelled) navigate('/admin', { replace: true }); })
      .catch(() => {
        localStorage.removeItem('vpn_admin_token');
      });
    return () => { cancelled = true; };
  }, [navigate]);

  const submit = async (event) => {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const result = await loginAdmin(email.trim().toLowerCase(), password);
      localStorage.setItem('vpn_admin_token', result.access_token);
      navigate('/admin', { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(Array.isArray(detail) ? detail.map((item) => item.msg).join('. ') : detail || 'Не удалось войти');
    } finally { setBusy(false); }
  };

  return <Box className="noise-bg" minHeight="100vh" display="grid" sx={{ placeItems: 'center' }}><Container maxWidth="xs"><Paper sx={{ p: 4 }}><Box component="img" src="/nox-logo.png" alt="NOX VPN" className="brand-logo" sx={{ mb: 4 }}/><Typography variant="h4">Вход администратора</Typography><Typography color="text.secondary" mt={1} mb={4}>Используйте почту и пароль администратора из настроек сервера.</Typography>{error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}<Box component="form" onSubmit={submit}><Stack spacing={2}><TextField autoFocus required type="email" autoComplete="username" label="Email администратора" value={email} onChange={(e) => setEmail(e.target.value)}/><TextField required type="password" autoComplete="current-password" label="Пароль" value={password} onChange={(e) => setPassword(e.target.value)}/><Button variant="contained" type="submit" disabled={busy || !email || !password}>{busy ? 'Проверяем…' : 'Войти'}</Button></Stack></Box></Paper></Container></Box>;
};

export default AdminLoginPage;
